import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useState } from 'react';
export function useCarousel(_ref) {
  var totalPages = _ref.totalPages,
    isInfinite = _ref.isInfinite;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var isFirstIndex = currentIndex === 0;
  var isLastIndex = currentIndex === totalPages - 1;
  var goToIndex = useCallback(function (index) {
    setCurrentIndex(index);
  }, []);
  var goToNextIndex = useCallback(function () {
    var nextIndex;
    if (isInfinite && isLastIndex) {
      nextIndex = 0;
    } else if (isLastIndex) {
      nextIndex = currentIndex;
    } else {
      nextIndex = currentIndex + 1;
    }
    goToIndex(nextIndex);
  }, [currentIndex, goToIndex, isInfinite, isLastIndex]);
  var goToPrevIndex = useCallback(function () {
    var prevIndex;
    if (isInfinite && isFirstIndex) {
      prevIndex = totalPages - 1;
    } else if (isFirstIndex) {
      prevIndex = currentIndex;
    } else {
      prevIndex = currentIndex - 1;
    }
    goToIndex(prevIndex);
  }, [currentIndex, goToIndex, isFirstIndex, isInfinite, totalPages]);
  return {
    currentIndex: currentIndex,
    goToIndex: goToIndex,
    goToNextIndex: goToNextIndex,
    goToPrevIndex: goToPrevIndex,
    isFirstIndex: isFirstIndex,
    isInfinite: isInfinite,
    isLastIndex: isLastIndex,
    totalPages: totalPages
  };
}